import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const fetchQaCalibrationReviewers = async () => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    query: graphql(`
      query QaCalibrationReviewers {
        qaCalibrationReviewers {
          id
          name
        }
      }
    `),
  });

  return response.data.qaCalibrationReviewers;
};
